import React from 'react';
import {Pagination} from 'react-bootstrap';

interface PaginationComponentProps {
    pages: number[] | null;
    currentPage: number | null;
    onPageChange: (page: number) => void;
    className?: string;
    centered?: boolean;
    hideWhenSinglePage?: boolean;
}

const PaginationComponent: React.FC<PaginationComponentProps> = ({
    pages,
    currentPage,
    onPageChange,
    className = 'mt-2',
    centered = false,
    hideWhenSinglePage = true,
}) => {
    if (!pages || pages.length === 0 || currentPage === null) {
        return null;
    }
    
    if (hideWhenSinglePage && pages.length <= 1) {
        return null;
    }

    const items = pages.map((page: number, index: number) => {
        if (page === -1) {
            // Render ellipsis for -1 values
            return (
                <Pagination.Ellipsis 
                    key={`ellipsis-${index}`}
                    disabled
                />
            );
        }
        
        return (
            <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => onPageChange(page)}
            >
                {page}
            </Pagination.Item>
        );
    });

    const containerClass = centered 
        ? `d-flex justify-content-center ${className}` 
        : className;

    return (
        <div className={containerClass}>
            <Pagination>{items}</Pagination>
        </div>
    );
};

export default PaginationComponent;
